import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArchivedMessages = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 111,
	height: 95,
	viewBox: "0 0 111 95",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M89.1463 86.218L20.0823 86.4997C25.4971 86.4555 29.878 82.0549 29.878 76.6303V27.282L101 27V74.3744C101 80.916 95.6856 86.218 89.1463 86.218Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.5 76V26H91.5V18H39.5V10H11.5V76C11.5 81.524 15.972 86 21.5 86C27.02 86 31.5 81.524 31.5 76Z",
			fill: "#F2F4FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M98.5 26C99.3284 26 100 26.6716 100 27.5V73.4886C100 80.3426 94.2788 85.8097 87.4319 85.4985L87.5681 82.5015C92.7064 82.7351 97 78.6323 97 73.4886V27.5C97 26.6716 97.6716 26 98.5 26Z",
			fill: "#F2F4FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22.6505 84.9871C21.6856 85.3115 20.6542 85.4909 19.5823 85.4997L88.6463 85.218C95.1856 85.218 100.5 79.916 100.5 73.3744V26L29.378 26.282V75.6303C29.378 79.9811 26.5599 83.6731 22.6505 84.9871ZM29.878 26.78V75.6303C29.878 79.7511 27.4722 83.309 23.9896 84.9817L88.6463 84.718C94.9101 84.718 100 79.6393 100 73.3744V26.502L29.878 26.78Z",
			fill: "#A5A8BA"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.25 9.25H37.575V17.25H89.25V25.5H88.75V17.75H37.075V9.75H9.75V75.5C9.75 80.8875 14.0837 85.25 19.4375 85.25C24.8141 85.25 29.25 81.6084 29.25 76.25H29.75C29.75 81.9396 25.0319 85.75 19.4375 85.75C13.8044 85.75 9.25 81.1605 9.25 75.5V9.25Z",
			fill: "#A5A8BA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.5 76V26H88.5V18H39.5V10H11.5V76C11.5 81.524 15.972 86 21.5 86C27.02 86 31.5 81.524 31.5 76Z",
			fill: "#F2F4FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.25 9.25H37.575V17.25H89.25V25.5H88.75V17.75H37.075V9.75H9.75V75.5C9.75 80.8875 14.0837 85.25 19.4375 85.25C24.8141 85.25 29.25 81.6084 29.25 76.25H29.75C29.75 81.9396 25.0319 85.75 19.4375 85.75C13.8044 85.75 9.25 81.1605 9.25 75.5V9.25Z",
			fill: "#A5A8BA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.75 22.75L34.9602 16.4164C35.3102 16.1464 35.7398 16 36.1818 16H55.5H93.5C94.6046 16 95.5 16.8954 95.5 18V77.5C95.5 78.6046 94.6046 79.5 93.5 79.5H17.5C16.3954 79.5 15.5 78.6046 15.5 77.5V47.75V32.828C15.5 32.2251 15.7719 31.6544 16.2401 31.2747L26.75 22.75Z",
			fill: "#E0E5F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M93.5 16.5H36.1818C35.8503 16.5 35.5281 16.6098 35.2656 16.8123L27.0602 23.1422L16.5551 31.663C16.2039 31.9478 16 32.3758 16 32.828V77.5C16 78.3284 16.6716 79 17.5 79H93.5C94.3284 79 95 78.3284 95 77.5V18C95 17.1716 94.3284 16.5 93.5 16.5ZM26.75 22.75L34.9602 16.4164C35.3102 16.1464 35.7397 16 36.1818 16H93.5C94.6046 16 95.5 16.8954 95.5 18V77.5C95.5 78.6046 94.6046 79.5 93.5 79.5H17.5C16.3954 79.5 15.5 78.6046 15.5 77.5V32.828C15.5 32.2251 15.7719 31.6544 16.2401 31.2747L26.75 22.75Z",
			fill: "#A5A8BA"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M35.25 17.5C35.25 17.0858 35.5858 16.75 36 16.75L94 16.75C94.4142 16.75 94.75 17.0858 94.75 17.5C94.75 17.9142 94.4142 18.25 94 18.25L36 18.25C35.5858 18.25 35.25 17.9142 35.25 17.5Z",
			fill: "#F2F4FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.25 27.25L41.4602 20.9164C41.8102 20.6464 42.2398 20.5 42.6818 20.5H62.5H93.5C94.6046 20.5 95.5 21.3954 95.5 22.5V77.5C95.5 78.6046 94.6046 79.5 93.5 79.5H24.5C23.3954 79.5 22.5 78.6046 22.5 77.5V51.75V37.3007C22.5 36.7135 22.7581 36.156 23.2057 35.7759L33.25 27.25Z",
			fill: "#F2F4FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M95 77.5V22.5C95 21.6716 94.3284 21 93.5 21H42.6818C42.3503 21 42.0281 21.1098 41.7656 21.3123L33.5647 27.6388L23.5293 36.1571C23.1935 36.4421 23 36.8603 23 37.3007V77.5C23 78.3284 23.6716 79 24.5 79H93.5C94.3284 79 95 78.3284 95 77.5ZM33.25 27.25L41.4602 20.9164C41.8102 20.6464 42.2397 20.5 42.6818 20.5H93.5C94.6046 20.5 95.5 21.3954 95.5 22.5V77.5C95.5 78.6046 94.6046 79.5 93.5 79.5H24.5C23.3954 79.5 22.5 78.6046 22.5 77.5V37.3007C22.5 36.7135 22.7581 36.156 23.2057 35.7759L33.25 27.25Z",
			fill: "#A5A8BA"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M42.5 21.25L93.5 21.25C93.9142 21.25 94.25 21.5858 94.25 22C94.25 22.4142 93.9142 22.75 93.5 22.75L42.5 22.75C42.0858 22.75 41.75 22.4142 41.75 22C41.75 21.5858 42.0858 21.25 42.5 21.25Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.1463 86.218L20.0823 86.4997C25.4971 86.4555 29.878 82.0549 29.878 76.6303V26.782L101 26.5V74.3744C101 80.916 95.6856 86.218 89.1463 86.218Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M98.5 26C99.3284 26 100 26.6716 100 27.5V73.4886C100 80.3426 94.2788 85.8097 87.4319 85.4985L87.5681 82.5015C92.7064 82.7351 97 78.6323 97 73.4886V27.5C97 26.6716 97.6716 26 98.5 26Z",
			fill: "#F2F4FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22.6505 84.9871C21.6856 85.3115 20.6542 85.4909 19.5823 85.4997L88.6463 85.218C95.1856 85.218 100.5 79.916 100.5 73.3744V26L29.378 26.282V75.6303C29.378 79.9811 26.5599 83.6731 22.6505 84.9871ZM29.878 26.78V75.6303C29.878 79.7511 27.4722 83.309 23.9896 84.9817L88.6463 84.718C94.9101 84.718 100 79.6393 100 73.3744V26.502L29.878 26.78Z",
			fill: "#A5A8BA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.8944 73.4859C75.1782 73.4859 82.7042 65.96 82.7042 56.6763C82.7042 47.3921 75.1782 39.8662 65.8944 39.8662C56.6106 39.8662 49.0845 47.3921 49.0845 56.6763C49.0845 65.96 56.6106 73.4859 65.8944 73.4859Z",
			fill: "#F2F4FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M48.8345 56.6763C48.8345 47.2541 56.4725 39.6162 65.8944 39.6162C75.3162 39.6162 82.9542 47.2541 82.9542 56.6763C82.9542 66.0981 75.3162 73.7359 65.8944 73.7359C56.4725 73.7359 48.8345 66.0981 48.8345 56.6763ZM65.8944 40.1162C56.7486 40.1162 49.3345 47.5302 49.3345 56.6763C49.3345 65.8219 56.7486 73.2359 65.8944 73.2359C75.0401 73.2359 82.4542 65.8219 82.4542 56.6763C82.4542 47.5302 75.0401 40.1162 65.8944 40.1162Z",
			fill: "#A5A8BA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M74.5 52.8623C74.5 51.7577 73.6046 50.8623 72.5 50.8623H59C57.8954 50.8623 57 51.7577 57 52.8623V59.447C57 60.5516 57.8954 61.447 59 61.447H59.9785C61.2165 61.447 62.3847 62.0202 63.1422 62.9993L63.6279 63.627C63.828 63.8857 64.2186 63.8857 64.4188 63.627L64.9044 62.9993C65.6619 62.0202 66.8301 61.447 68.0681 61.447H68.1875H72.5C73.6046 61.447 74.5 60.5516 74.5 59.447V52.8623Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M74.75 52.8623C74.75 51.6197 73.7426 50.6123 72.5 50.6123H59C57.7574 50.6123 56.75 51.6197 56.75 52.8623V59.447C56.75 60.6896 57.7574 61.697 59 61.697H59.9785C61.1391 61.697 62.2343 62.2344 62.9445 63.1523L63.4301 63.78C63.7304 64.1681 64.3163 64.1681 64.6165 63.78L65.1021 63.1523C65.8123 62.2344 66.9075 61.697 68.0681 61.697H72.5C73.7426 61.697 74.75 60.6896 74.75 59.447V52.8623ZM72.5 51.1123C73.4665 51.1123 74.25 51.8958 74.25 52.8623V59.447C74.25 60.4135 73.4665 61.197 72.5 61.197H68.0681C66.7528 61.197 65.5115 61.806 64.7067 62.8464L64.2211 63.474C64.121 63.6034 63.9257 63.6034 63.8256 63.474L63.34 62.8464C62.5351 61.806 61.2939 61.197 59.9785 61.197H59C58.0335 61.197 57.25 60.4135 57.25 59.447V52.8623C57.25 51.8958 58.0335 51.1123 59 51.1123H72.5Z",
			fill: "#A5A8BA"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M67.2586 54.1299H61.2242V53.6299H67.2586V54.1299Z",
			fill: "#A5A8BA"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M70.5776 56.543H61.2242V56.043H70.5776V56.543Z",
			fill: "#A5A8BA"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M70.5776 58.957H61.2242V58.457H70.5776V58.957Z",
			fill: "#A5A8BA"
		})
	]
});
const ForwardRef = forwardRef(SvgArchivedMessages);
export default ForwardRef;
